// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createCrmObjectRequestToJson, createCrmObjectResponseFromJson, deleteCrmObjectRequestToJson, getMultiCrmObjectRequestToJson, getMultiCrmObjectResponseFromJson, getOpportunityValueSummaryRequestToJson, getOpportunityValueSummaryResponseFromJson, listCrmObjectsRequestToJson, listCrmObjectsResponseFromJson, listFieldOptionsRequestToJson, listFieldOptionsResponseFromJson, listFiltersRequestToJson, listFiltersResponseFromJson, restoreCrmObjectRequestToJson, updateCrmObjectRequestToJson, validateCrmObjectRequestToJson, validateCrmObjectResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createOpportunity(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/CreateOpportunity', createCrmObjectRequestToJson(request));
    return createCrmObjectResponseFromJson(raw);
}
export function createOpportunity$(request, options) {
    return defer(() => createOpportunityWithTransport$(getGlobalTransport(), request, options));
}
export function createOpportunityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/CreateOpportunity', createCrmObjectRequestToJson(request), options)
        .pipe(map(resp => createCrmObjectResponseFromJson(resp)));
}
export async function updateOpportunity(request) {
    await fetchRpc('crm.v1.CRMOpportunityService/UpdateOpportunity', updateCrmObjectRequestToJson(request));
}
export function updateOpportunity$(request, options) {
    return defer(() => updateOpportunityWithTransport$(getGlobalTransport(), request, options));
}
export function updateOpportunityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/UpdateOpportunity', updateCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getMultiOpportunity(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/GetMultiOpportunity', getMultiCrmObjectRequestToJson(request));
    return getMultiCrmObjectResponseFromJson(raw);
}
export function getMultiOpportunity$(request, options) {
    return defer(() => getMultiOpportunityWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiOpportunityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/GetMultiOpportunity', getMultiCrmObjectRequestToJson(request), options)
        .pipe(map(resp => getMultiCrmObjectResponseFromJson(resp)));
}
export async function listOpportunities(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/ListOpportunities', listCrmObjectsRequestToJson(request));
    return listCrmObjectsResponseFromJson(raw);
}
export function listOpportunities$(request, options) {
    return defer(() => listOpportunitiesWithTransport$(getGlobalTransport(), request, options));
}
export function listOpportunitiesWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/ListOpportunities', listCrmObjectsRequestToJson(request), options)
        .pipe(map(resp => listCrmObjectsResponseFromJson(resp)));
}
export async function listOpportunitiesFilters(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/ListOpportunitiesFilters', listFiltersRequestToJson(request));
    return listFiltersResponseFromJson(raw);
}
export function listOpportunitiesFilters$(request, options) {
    return defer(() => listOpportunitiesFiltersWithTransport$(getGlobalTransport(), request, options));
}
export function listOpportunitiesFiltersWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/ListOpportunitiesFilters', listFiltersRequestToJson(request), options)
        .pipe(map(resp => listFiltersResponseFromJson(resp)));
}
export async function deleteOpportunity(request) {
    await fetchRpc('crm.v1.CRMOpportunityService/DeleteOpportunity', deleteCrmObjectRequestToJson(request));
}
export function deleteOpportunity$(request, options) {
    return defer(() => deleteOpportunityWithTransport$(getGlobalTransport(), request, options));
}
export function deleteOpportunityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/DeleteOpportunity', deleteCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function restoreOpportunity(request) {
    await fetchRpc('crm.v1.CRMOpportunityService/RestoreOpportunity', restoreCrmObjectRequestToJson(request));
}
export function restoreOpportunity$(request, options) {
    return defer(() => restoreOpportunityWithTransport$(getGlobalTransport(), request, options));
}
export function restoreOpportunityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/RestoreOpportunity', restoreCrmObjectRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getOpportunityValueSummary(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/GetOpportunityValueSummary', getOpportunityValueSummaryRequestToJson(request));
    return getOpportunityValueSummaryResponseFromJson(raw);
}
export function getOpportunityValueSummary$(request, options) {
    return defer(() => getOpportunityValueSummaryWithTransport$(getGlobalTransport(), request, options));
}
export function getOpportunityValueSummaryWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/GetOpportunityValueSummary', getOpportunityValueSummaryRequestToJson(request), options)
        .pipe(map(resp => getOpportunityValueSummaryResponseFromJson(resp)));
}
export async function listOpportunityFieldOptions(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/ListOpportunityFieldOptions', listFieldOptionsRequestToJson(request));
    return listFieldOptionsResponseFromJson(raw);
}
export function listOpportunityFieldOptions$(request, options) {
    return defer(() => listOpportunityFieldOptionsWithTransport$(getGlobalTransport(), request, options));
}
export function listOpportunityFieldOptionsWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/ListOpportunityFieldOptions', listFieldOptionsRequestToJson(request), options)
        .pipe(map(resp => listFieldOptionsResponseFromJson(resp)));
}
export async function validateOpportunity(request) {
    const raw = await fetchRpc('crm.v1.CRMOpportunityService/ValidateOpportunity', validateCrmObjectRequestToJson(request));
    return validateCrmObjectResponseFromJson(raw);
}
export function validateOpportunity$(request, options) {
    return defer(() => validateOpportunityWithTransport$(getGlobalTransport(), request, options));
}
export function validateOpportunityWithTransport$(transport, request, options) {
    return transport
        .post('crm.v1.CRMOpportunityService/ValidateOpportunity', validateCrmObjectRequestToJson(request), options)
        .pipe(map(resp => validateCrmObjectResponseFromJson(resp)));
}
